import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
export const Hero = () => {
  return <section id="inicio" className="relative pt-24 pb-16 overflow-hidden bg-beige-50" data-id="element-306">
      {/* Clean cenital spotlight from above */}
      <div className="absolute inset-x-0 top-0 h-[850px] pointer-events-none z-0 overflow-hidden" data-id="element-307">
        <div className="absolute left-1/2 top-0 -translate-x-1/2" style={{
        width: '85%',
        maxWidth: '1100px',
        height: '850px',
        background: 'radial-gradient(ellipse 60% 80% at 50% 0%, rgba(232, 201, 136, 0.4) 0%, rgba(212, 180, 131, 0.18) 30%, rgba(212, 180, 131, 0.06) 55%, transparent 75%)'
      }} data-id="element-308" />
        <div className="absolute left-1/2 top-0 -translate-x-1/2" style={{
        width: '50%',
        maxWidth: '650px',
        height: '650px',
        background: 'radial-gradient(ellipse 50% 70% at 50% 0%, rgba(255, 240, 200, 0.45) 0%, transparent 65%)'
      }} data-id="element-309" />
        <div className="absolute top-[100px] left-[38%] w-2 h-2 bg-white/70 rounded-full blur-[1px]" data-id="element-310"></div>
        <div className="absolute top-[180px] right-[38%] w-3 h-3 bg-gold-300/50 rounded-full blur-[2px]" data-id="element-311"></div>
        <div className="absolute top-[260px] left-[45%] w-2 h-2 bg-white/60 rounded-full blur-[1px]" data-id="element-312"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-313">
        {/* Banner — clean, no frame */}
        <div className="relative mb-14" data-id="element-314">
          <div className="relative rounded-2xl overflow-hidden" style={{
          boxShadow: '0 30px 70px -20px rgba(120, 80, 30, 0.3), 0 12px 30px -8px rgba(120, 80, 30, 0.18)'
        }} data-id="element-315">
            <img src="https://cdn.magicpatterns.com/uploads/rexcfYr3uGLcLzq5nadrs1/banner_stef.png" alt="Alisados Stefania Becerra - Transforma tu cabello sin químicos agresivos" className="w-full h-auto object-contain block" data-id="element-316" />
          </div>
        </div>

        {/* Content below banner */}
        <div className="text-center max-w-4xl mx-auto" data-id="element-317">
          {/* Script accent — Sacramento */}
          <div className="mb-4" data-id="element-318">
            <span className="font-script text-4xl sm:text-5xl md:text-6xl metallic-gold-text-static" data-id="element-319">
              Cabello sin esfuerzo
            </span>
          </div>

          {/* Main headline — Cormorant Garamond, lighter and refined */}
          <h1 className="font-elegant font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tight" data-id="element-320">
            <span className="rich-brown-text" data-id="element-321">
              Despierta cada día
              <br data-id="element-322" />
              con un cabello impecable
            </span>
          </h1>

          {/* Decorative ornament */}
          <div className="flex items-center justify-center gap-4 my-8" aria-hidden="true" data-id="element-323">
            <div className="h-px flex-1 max-w-[120px]" style={{
            background: 'linear-gradient(to right, transparent, #C9B58A 60%, #B8A580)'
          }} data-id="element-324" />
            <div className="relative flex items-center justify-center" data-id="element-325">
              <div className="w-2.5 h-2.5 rotate-45" style={{
              background: 'linear-gradient(135deg, #F0E1C5, #C9B58A 60%, #B8A580)',
              boxShadow: '0 0 8px rgba(220, 200, 160, 0.6)'
            }} data-id="element-326" />
              <div className="absolute w-3 h-3 rotate-45 opacity-30" style={{
              border: '1px solid #C9B58A'
            }} data-id="element-327" />
            </div>
            <div className="h-px flex-1 max-w-[120px]" style={{
            background: 'linear-gradient(to left, transparent, #C9B58A 60%, #B8A580)'
          }} data-id="element-328" />
          </div>

          <p className="text-lg sm:text-xl mb-10 font-light max-w-2xl mx-auto" style={{
          color: '#3B2E22'
        }} data-id="element-329">
            Sin plancha, sin frizz, sin químicos. La nanotecnología que repara
            tu cabello desde adentro y lo deja liso hasta{' '}
            <span className="metallic-gold-text-static font-semibold" data-id="element-330">
              8 meses
            </span>
            .
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-331">
            <a href="https://wa.me/13479909488?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20cita%20%E2%9C%A8" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto metallic-gold-button px-8 py-4 rounded-full text-base font-medium flex items-center justify-center group shadow-xl hover:shadow-2xl transition-all hover:-translate-y-0.5" data-id="element-332">
              Agenda tu cita
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-333" />
            </a>
            <a href="#servicios" className="w-full sm:w-auto bg-white border-2 border-gold-400 px-8 py-4 rounded-full text-base font-medium flex items-center justify-center hover:bg-beige-50 transition-all" data-id="element-334">
              <span className="metallic-gold-text-static" data-id="element-335">
                Conoce el tratamiento
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>;
};